/** Safe in-app path for post-login redirect (blocks open redirects). */
export const sanitizeNextPath = (raw: string | null | undefined, fallback = "/"): string => {
  if (!raw) return fallback;
  if (!raw.startsWith("/") || raw.startsWith("//")) return fallback;
  return raw;
};

export const loginWithNext = (nextPath: string) =>
  `/login?next=${encodeURIComponent(sanitizeNextPath(nextPath))}`;

export const signupWithNext = (nextPath: string) =>
  `/signup?next=${encodeURIComponent(sanitizeNextPath(nextPath))}`;

/** Start/create wedding CTA: go straight to create when signed in. */
export const createWeddingHref = (isSignedIn: boolean) =>
  isSignedIn ? "/weddings/create" : "/signup";
